export default __webpack_public_path__ + "static/media/metamask_steps_3.fe994bed.png";